import React, { FC, useCallback, useState } from "react";
import AuthCheckUserFormContainer from "../AuthCheckUserFormContainer";
import AuthSelectPhoneFormContainer from "../AuthSelectPhoneFormContainer";
import AuthConfirmUserFormContainer from "../AuthConfirmUserFormContainer";

type Step =
  | { name: "email" }
  | {
      name: "phone_select";
      email: string;
      primaryPhoneNumber: string;
      additionalPhoneNumber: string;
    }
  | {
      name: "code";
      email: string;
      phoneNumber: string;
      phoneType?: "primary" | "additional";
    };

const AuthLoginFormContainer: FC = () => {
  const [step, setStep] = useState<Step>({ name: "email" });

  const handleCheckUserSubmit = useCallback(
    (params: {
      phoneNumber: string;
      additionalPhoneNumber?: string;
      email: string;
    }) => {
      if (params.additionalPhoneNumber) {
        setStep({
          name: "phone_select",
          email: params.email,
          primaryPhoneNumber: params.phoneNumber,
          additionalPhoneNumber: params.additionalPhoneNumber,
        });
      } else {
        setStep({
          name: "code",
          email: params.email,
          phoneNumber: params.phoneNumber,
        });
      }
    },
    [],
  );

  const handlePhoneSelected = useCallback(
    (params: { phoneNumber: string; phoneType: "primary" | "additional" }) => {
      setStep((prev) => {
        if (prev.name !== "phone_select") return prev;
        return {
          name: "code",
          email: prev.email,
          phoneNumber: params.phoneNumber,
          phoneType: params.phoneType,
        };
      });
    },
    [],
  );

  if (step.name === "email") {
    return <AuthCheckUserFormContainer handleSubmit={handleCheckUserSubmit} />;
  }

  if (step.name === "phone_select") {
    return (
      <AuthSelectPhoneFormContainer
        email={step.email}
        primaryPhoneNumber={step.primaryPhoneNumber}
        additionalPhoneNumber={step.additionalPhoneNumber}
        onPhoneSelected={handlePhoneSelected}
      />
    );
  }

  return (
    <AuthConfirmUserFormContainer
      email={step.email}
      phoneNumber={step.phoneNumber}
      phoneType={step.phoneType}
    />
  );
};

export default AuthLoginFormContainer;
